import React, { type FC } from 'react';

import Row from '@amzn/meridian/row';
import Tag, { type TagType } from '@amzn/meridian/tag/tag';
import Text from '@amzn/meridian/text';

export interface CardHeaderProps {
  taskName: string;
  additionalTags?: Array<{ label: string; type: TagType }>;
  dataCy?: string;
}

const CardHeader: FC<CardHeaderProps> = ({ taskName, additionalTags, dataCy }) => (
  <Row alignmentVertical="center" widths={['fit', 'fill']}>
    <Text data-cy={dataCy} type="h100">
      {taskName}
    </Text>
    <Row>
      {additionalTags?.map(({ label, type }) => (
        <Tag key={label} type={type}>
          {label}
        </Tag>
      ))}
    </Row>
  </Row>
);

export default CardHeader;
